import { css } from 'styled-components';

const Form = css`

justify-content: flex-end;

.legoFormSubmitButton {
    background-color: #75B753;
    border-radius: 40px;
    color: #fff;
    padding: 0px 0px;
    font-size: 16px;
    width: 170px;
    height: 40px;
    min-height: 0px;
    margin-top: 20px;
  }
`;

export default Form;
